export const data = [
  { round: 1, team: "Arsenal FC", score: 3 },
  { round: 1, team: "Brighton & Hove Albion FC", score: 3 },
  { round: 1, team: "Burnley FC", score: 3 },
  { round: 1, team: "Liverpool FC", score: 3 },
  { round: 1, team: "Manchester City FC", score: 3 },
  { round: 1, team: "Manchester United FC", score: 3 },
  { round: 1, team: "Tottenham Hotspur FC", score: 3 },
  { round: 1, team: "Wolverhampton Wanderers FC", score: 1 },
  { round: 1, team: "Leicester City FC", score: 1 },
  { round: 1, team: "Sheffield United FC", score: 1 },
  { round: 1, team: "Crystal Palace FC", score: 1 },
  { round: 1, team: "Everton FC", score: 1 },
  { round: 1, team: "AFC Bournemouth", score: 1 },
  { round: 1, team: "Aston Villa FC", score: 0 },
  { round: 1, team: "Chelsea FC", score: 0 },
  { round: 1, team: "Southampton FC", score: 0 },
  { round: 1, team: "Newcastle United FC", score: 0 },
  { round: 1, team: "Norwich City FC", score: 0 },
  { round: 1, team: "West Ham United FC", score: 0 },
  { round: 1, team: "Watford FC", score: 0 },
  { round: 2, team: "Liverpool FC", score: 6 },
  { round: 2, team: "Arsenal FC", score: 6 },
  { round: 2, team: "AFC Bournemouth", score: 4 },
  { round: 2, team: "Brighton & Hove Albion FC", score: 4 },
  { round: 2, team: "Everton FC", score: 4 },
  { round: 2, team: "Manchester United FC", score: 4 },
  { round: 2, team: "Manchester City FC", score: 4 },
  { round: 2, team: "Sheffield United FC", score: 4 },
  { round: 2, team: "Tottenham Hotspur FC", score: 4 },
  { round: 2, team: "Norwich City FC", score: 3 },
  { round: 2, team: "Burnley FC", score: 3 },
  { round: 2, team: "Leicester City FC", score: 2 },
  { round: 2, team: "Wolverhampton Wanderers FC", score: 2 },
  { round: 2, team: "West Ham United FC", score: 1 },
  { round: 2, team: "Chelsea FC", score: 1 },
  { round: 2, team: "Crystal Palace FC", score: 1 },
  { round: 2, team: "Aston Villa FC", score: 0 },
  { round: 2, team: "Newcastle United FC", score: 0 },
  { round: 2, team: "Southampton FC", score: 0 },
  { round: 2, team: "Watford FC", score: 0 },
  { round: 3, team: "Liverpool FC", score: 9 },
  { round: 3, team: "Manchester City FC", score: 7 },
  { round: 3, team: "Arsenal FC", score: 6 },
  { round: 3, team: "Leicester City FC", score: 5 },
  { round: 3, team: "Manchester United FC", score: 4 },
  { round: 3, team: "Sheffield United FC", score: 4 },
  { round: 3, team: "AFC Bournemouth", score: 4 },
  { round: 3, team: "Brighton & Hove Albion FC", score: 4 },
  { round: 3, team: "Crystal Palace FC", score: 4 },
  { round: 3, team: "Everton FC", score: 4 },
  { round: 3, team: "Chelsea FC", score: 4 },
  { round: 3, team: "Burnley FC", score: 4 },
  { round: 3, team: "Tottenham Hotspur FC", score: 4 },
  { round: 3, team: "West Ham United FC", score: 4 },
  { round: 3, team: "Wolverhampton Wanderers FC", score: 3 },
  { round: 3, team: "Aston Villa FC", score: 3 },
  { round: 3, team: "Southampton FC", score: 3 },
  { round: 3, team: "Newcastle United FC", score: 3 },
  { round: 3, team: "Norwich City FC", score: 3 },
  { round: 3, team: "Watford FC", score: 0 },
  { round: 4, team: "Liverpool FC", score: 12 },
  { round: 4, team: "Manchester City FC", score: 10 },
  { round: 4, team: "Leicester City FC", score: 8 },
  { round: 4, team: "Arsenal FC", score: 7 },
  { round: 4, team: "Everton FC", score: 7 },
  { round: 4, team: "Crystal Palace FC", score: 7 },
  { round: 4, team: "West Ham United FC", score: 7 },
  { round: 4, team: "Tottenham Hotspur FC", score: 5 },
  { round: 4, team: "Chelsea FC", score: 5 },
  { round: 4, team: "Manchester United FC", score: 5 },
  { round: 4, team: "Sheffield United FC", score: 5 },
  { round: 4, team: "Southampton FC", score: 4 },
  { round: 4, team: "Newcastle United FC", score: 4 },
  { round: 4, team: "Burnley FC", score: 4 },
  { round: 4, team: "AFC Bournemouth", score: 4 },
  { round: 4, team: "Brighton & Hove Albion FC", score: 4 },
  { round: 4, team: "Aston Villa FC", score: 3 },
  { round: 4, team: "Norwich City FC", score: 3 },
  { round: 4, team: "Wolverhampton Wanderers FC", score: 3 },
  { round: 4, team: "Watford FC", score: 1 },
  { round: 5, team: "Liverpool FC", score: 15 },
  { round: 5, team: "Manchester City FC", score: 10 },
  { round: 5, team: "Manchester United FC", score: 8 },
  { round: 5, team: "Leicester City FC", score: 8 },
  { round: 5, team: "Arsenal FC", score: 8 },
  { round: 5, team: "Chelsea FC", score: 8 },
  { round: 5, team: "Tottenham Hotspur FC", score: 8 },
  { round: 5, team: "West Ham United FC", score: 8 },
  { round: 5, team: "Crystal Palace FC", score: 7 },
  { round: 5, team: "Everton FC", score: 7 },
  { round: 5, team: "AFC Bournemouth", score: 7 },
  { round: 5, team: "Southampton FC", score: 7 },
  { round: 5, team: "Norwich City FC", score: 6 },
  { round: 5, team: "Sheffield United FC", score: 5 },
  { round: 5, team: "Brighton & Hove Albion FC", score: 5 },
  { round: 5, team: "Burnley FC", score: 5 },
  { round: 5, team: "Aston Villa FC", score: 4 },
  { round: 5, team: "Newcastle United FC", score: 4 },
  { round: 5, team: "Wolverhampton Wanderers FC", score: 3 },
  { round: 5, team: "Watford FC", score: 2 },
  { round: 6, team: "Liverpool FC", score: 18 },
  { round: 6, team: "Manchester City FC", score: 13 },
  { round: 6, team: "Leicester City FC", score: 11 },
  { round: 6, team: "Arsenal FC", score: 11 },
  { round: 6, team: "West Ham United FC", score: 11 },
  { round: 6, team: "AFC Bournemouth", score: 10 },
  { round: 6, team: "Burnley FC", score: 8 },
  { round: 6, team: "Chelsea FC", score: 8 },
  { round: 6, team: "Crystal Palace FC", score: 8 },
  { round: 6, team: "Manchester United FC", score: 8 },
  { round: 6, team: "Sheffield United FC", score: 8 },
  { round: 6, team: "Tottenham Hotspur FC", score: 8 },
  { round: 6, team: "Southampton FC", score: 7 },
  { round: 6, team: "Everton FC", score: 7 },
  { round: 6, team: "Brighton & Hove Albion FC", score: 6 },
  { round: 6, team: "Norwich City FC", score: 6 },
  { round: 6, team: "Newcastle United FC", score: 5 },
  { round: 6, team: "Aston Villa FC", score: 4 },
  { round: 6, team: "Wolverhampton Wanderers FC", score: 4 },
  { round: 6, team: "Watford FC", score: 2 },
  { round: 7, team: "Liverpool FC", score: 21 },
  { round: 7, team: "Manchester City FC", score: 16 },
  { round: 7, team: "Leicester City FC", score: 14 },
  { round: 7, team: "Arsenal FC", score: 12 },
  { round: 7, team: "West Ham United FC", score: 12 },
  { round: 7, team: "Tottenham Hotspur FC", score: 11 },
  { round: 7, team: "AFC Bournemouth", score: 11 },
  { round: 7, team: "Crystal Palace FC", score: 11 },
  { round: 7, team: "Chelsea FC", score: 11 },
  { round: 7, team: "Burnley FC", score: 9 },
  { round: 7, team: "Manchester United FC", score: 9 },
  { round: 7, team: "Sheffield United FC", score: 8 },
  { round: 7, team: "Southampton FC", score: 7 },
  { round: 7, team: "Everton FC", score: 7 },
  { round: 7, team: "Wolverhampton Wanderers FC", score: 7 },
  { round: 7, team: "Brighton & Hove Albion FC", score: 6 },
  { round: 7, team: "Norwich City FC", score: 6 },
  { round: 7, team: "Newcastle United FC", score: 5 },
  { round: 7, team: "Aston Villa FC", score: 5 },
  { round: 7, team: "Watford FC", score: 2 },
  { round: 8, team: "Liverpool FC", score: 24 },
  { round: 8, team: "Manchester City FC", score: 16 },
  { round: 8, team: "Arsenal FC", score: 15 },
  { round: 8, team: "Crystal Palace FC", score: 14 },
  { round: 8, team: "Chelsea FC", score: 14 },
  { round: 8, team: "Leicester City FC", score: 14 },
  { round: 8, team: "Burnley FC", score: 12 },
  { round: 8, team: "West Ham United FC", score: 12 },
  { round: 8, team: "Tottenham Hotspur FC", score: 11 },
  { round: 8, team: "AFC Bournemouth", score: 11 },
  { round: 8, team: "Wolverhampton Wanderers FC", score: 10 },
  { round: 8, team: "Brighton & Hove Albion FC", score: 9 },
  { round: 8, team: "Manchester United FC", score: 9 },
  { round: 8, team: "Sheffield United FC", score: 9 },
  { round: 8, team: "Newcastle United FC", score: 8 },
  { round: 8, team: "Aston Villa FC", score: 8 },
  { round: 8, team: "Everton FC", score: 7 },
  { round: 8, team: "Southampton FC", score: 7 },
  { round: 8, team: "Norwich City FC", score: 6 },
  { round: 8, team: "Watford FC", score: 3 },
  { round: 9, team: "Liverpool FC", score: 25 },
  { round: 9, team: "Manchester City FC", score: 19 },
  { round: 9, team: "Leicester City FC", score: 17 },
  { round: 9, team: "Chelsea FC", score: 17 },
  { round: 9, team: "Arsenal FC", score: 15 },
  { round: 9, team: "Crystal Palace FC", score: 14 },
  { round: 9, team: "Burnley FC", score: 12 },
  { round: 9, team: "AFC Bournemouth", score: 12 },
  { round: 9, team: "Sheffield United FC", score: 12 },
  { round: 9, team: "Tottenham Hotspur FC", score: 12 },
  { round: 9, team: "West Ham United FC", score: 12 },
  { round: 9, team: "Wolverhampton Wanderers FC", score: 11 },
  { round: 9, team: "Aston Villa FC", score: 11 },
  { round: 9, team: "Everton FC", score: 10 },
  { round: 9, team: "Manchester United FC", score: 10 },
  { round: 9, team: "Brighton & Hove Albion FC", score: 9 },
  { round: 9, team: "Southampton FC", score: 8 },
  { round: 9, team: "Newcastle United FC", score: 8 },
  { round: 9, team: "Norwich City FC", score: 7 },
  { round: 9, team: "Watford FC", score: 4 },
  { round: 10, team: "Liverpool FC", score: 28 },
  { round: 10, team: "Manchester City FC", score: 22 },
  { round: 10, team: "Leicester City FC", score: 20 },
  { round: 10, team: "Chelsea FC", score: 20 },
  { round: 10, team: "Arsenal FC", score: 16 },
  { round: 10, team: "Crystal Palace FC", score: 15 },
  { round: 10, team: "AFC Bournemouth", score: 13 },
  { round: 10, team: "Manchester United FC", score: 13 },
  { round: 10, team: "Sheffield United FC", score: 13 },
  { round: 10, team: "West Ham United FC", score: 13 },
  { round: 10, team: "Wolverhampton Wanderers FC", score: 12 },
  { round: 10, team: "Tottenham Hotspur FC", score: 12 },
  { round: 10, team: "Brighton & Hove Albion FC", score: 12 },
  { round: 10, team: "Burnley FC", score: 12 },
  { round: 10, team: "Aston Villa FC", score: 11 },
  { round: 10, team: "Everton FC", score: 10 },
  { round: 10, team: "Newcastle United FC", score: 9 },
  { round: 10, team: "Southampton FC", score: 8 },
  { round: 10, team: "Norwich City FC", score: 7 },
  { round: 10, team: "Watford FC", score: 5 },
  { round: 11, team: "Liverpool FC", score: 31 },
  { round: 11, team: "Manchester City FC", score: 25 },
  { round: 11, team: "Leicester City FC", score: 23 },
  { round: 11, team: "Chelsea FC", score: 23 },
  { round: 11, team: "Arsenal FC", score: 17 },
  { round: 11, team: "AFC Bournemouth", score: 16 },
  { round: 11, team: "Sheffield United FC", score: 16 },
  { round: 11, team: "Brighton & Hove Albion FC", score: 15 },
  { round: 11, team: "Crystal Palace FC", score: 15 },
  { round: 11, team: "Manchester United FC", score: 13 },
  { round: 11, team: "Tottenham Hotspur FC", score: 13 },
  { round: 11, team: "Wolverhampton Wanderers FC", score: 13 },
  { round: 11, team: "West Ham United FC", score: 13 },
  { round: 11, team: "Newcastle United FC", score: 12 },
  { round: 11, team: "Burnley FC", score: 12 },
  { round: 11, team: "Everton FC", score: 11 },
  { round: 11, team: "Aston Villa FC", score: 11 },
  { round: 11, team: "Southampton FC", score: 8 },
  { round: 11, team: "Norwich City FC", score: 7 },
  { round: 11, team: "Watford FC", score: 5 },
  { round: 12, team: "Liverpool FC", score: 34 },
  { round: 12, team: "Leicester City FC", score: 26 },
  { round: 12, team: "Chelsea FC", score: 26 },
  { round: 12, team: "Manchester City FC", score: 25 },
  { round: 12, team: "Sheffield United FC", score: 17 },
  { round: 12, team: "Arsenal FC", score: 17 },
  { round: 12, team: "AFC Bournemouth", score: 16 },
  { round: 12, team: "Manchester United FC", score: 16 },
  { round: 12, team: "Wolverhampton Wanderers FC", score: 16 },
  { round: 12, team: "Newcastle United FC", score: 15 },
  { round: 12, team: "Brighton & Hove Albion FC", score: 15 },
  { round: 12, team: "Burnley FC", score: 15 },
  { round: 12, team: "Crystal Palace FC", score: 15 },
  { round: 12, team: "Everton FC", score: 14 },
  { round: 12, team: "Tottenham Hotspur FC", score: 14 },
  { round: 12, team: "West Ham United FC", score: 13 },
  { round: 12, team: "Aston Villa FC", score: 11 },
  { round: 12, team: "Southampton FC", score: 8 },
  { round: 12, team: "Watford FC", score: 8 },
  { round: 12, team: "Norwich City FC", score: 7 },
  { round: 13, team: "Liverpool FC", score: 37 },
  { round: 13, team: "Leicester City FC", score: 29 },
  { round: 13, team: "Manchester City FC", score: 28 },
  { round: 13, team: "Chelsea FC", score: 26 },
  { round: 13, team: "Wolverhampton Wanderers FC", score: 19 },
  { round: 13, team: "Burnley FC", score: 18 },
  { round: 13, team: "Arsenal FC", score: 18 },
  { round: 13, team: "Sheffield United FC", score: 18 },
  { round: 13, team: "Manchester United FC", score: 17 },
  { round: 13, team: "Tottenham Hotspur FC", score: 17 },
  { round: 13, team: "AFC Bournemouth", score: 16 },
  { round: 13, team: "Brighton & Hove Albion FC", score: 15 },
  { round: 13, team: "Crystal Palace FC", score: 15 },
  { round: 13, team: "Newcastle United FC", score: 15 },
  { round: 13, team: "Everton FC", score: 14 },
  { round: 13, team: "Aston Villa FC", score: 14 },
  { round: 13, team: "West Ham United FC", score: 13 },
  { round: 13, team: "Norwich City FC", score: 10 },
  { round: 13, team: "Southampton FC", score: 9 },
  { round: 13, team: "Watford FC", score: 8 },
  { round: 14, team: "Liverpool FC", score: 40 },
  { round: 14, team: "Leicester City FC", score: 32 },
  { round: 14, team: "Manchester City FC", score: 29 },
  { round: 14, team: "Chelsea FC", score: 26 },
  { round: 14, team: "Tottenham Hotspur FC", score: 20 },
  { round: 14, team: "Wolverhampton Wanderers FC", score: 20 },
  { round: 14, team: "Arsenal FC", score: 19 },
  { round: 14, team: "Sheffield United FC", score: 19 },
  { round: 14, team: "Manchester United FC", score: 18 },
  { round: 14, team: "Burnley FC", score: 18 },
  { round: 14, team: "Crystal Palace FC", score: 18 },
  { round: 14, team: "AFC Bournemouth", score: 16 },
  { round: 14, team: "Newcastle United FC", score: 16 },
  { round: 14, team: "West Ham United FC", score: 16 },
  { round: 14, team: "Aston Villa FC", score: 15 },
  { round: 14, team: "Brighton & Hove Albion FC", score: 15 },
  { round: 14, team: "Everton FC", score: 14 },
  { round: 14, team: "Southampton FC", score: 12 },
  { round: 14, team: "Norwich City FC", score: 11 },
  { round: 14, team: "Watford FC", score: 8 },
  { round: 15, team: "Liverpool FC", score: 43 },
  { round: 15, team: "Leicester City FC", score: 35 },
  { round: 15, team: "Manchester City FC", score: 32 },
  { round: 15, team: "Chelsea FC", score: 29 },
  { round: 15, team: "Wolverhampton Wanderers FC", score: 23 },
  { round: 15, team: "Crystal Palace FC", score: 21 },
  { round: 15, team: "Manchester United FC", score: 21 },
  { round: 15, team: "Tottenham Hotspur FC", score: 20 },
  { round: 15, team: "Newcastle United FC", score: 19 },
  { round: 15, team: "Sheffield United FC", score: 19 },
  { round: 15, team: "Arsenal FC", score: 19 },
  { round: 15, team: "Brighton & Hove Albion FC", score: 18 },
  { round: 15, team: "Burnley FC", score: 18 },
  { round: 15, team: "AFC Bournemouth", score: 16 },
  { round: 15, team: "West Ham United FC", score: 16 },
  { round: 15, team: "Aston Villa FC", score: 15 },
  { round: 15, team: "Southampton FC", score: 15 },
  { round: 15, team: "Everton FC", score: 14 },
  { round: 15, team: "Norwich City FC", score: 11 },
  { round: 15, team: "Watford FC", score: 8 },
  { round: 16, team: "Liverpool FC", score: 46 },
  { round: 16, team: "Leicester City FC", score: 38 },
  { round: 16, team: "Manchester City FC", score: 32 },
  { round: 16, team: "Chelsea FC", score: 29 },
  { round: 16, team: "Manchester United FC", score: 24 },
  { round: 16, team: "Wolverhampton Wanderers FC", score: 24 },
  { round: 16, team: "Tottenham Hotspur FC", score: 23 },
  { round: 16, team: "Newcastle United FC", score: 22 },
  { round: 16, team: "Sheffield United FC", score: 22 },
  { round: 16, team: "Crystal Palace FC", score: 22 },
  { round: 16, team: "Arsenal FC", score: 22 },
  { round: 16, team: "Brighton & Hove Albion FC", score: 19 },
  { round: 16, team: "Burnley FC", score: 18 },
  { round: 16, team: "Everton FC", score: 17 },
  { round: 16, team: "AFC Bournemouth", score: 16 },
  { round: 16, team: "West Ham United FC", score: 16 },
  { round: 16, team: "Aston Villa FC", score: 15 },
  { round: 16, team: "Southampton FC", score: 15 },
  { round: 16, team: "Norwich City FC", score: 11 },
  { round: 16, team: "Watford FC", score: 9 },
  { round: 17, team: "Liverpool FC", score: 49 },
  { round: 17, team: "Leicester City FC", score: 39 },
  { round: 17, team: "Manchester City FC", score: 35 },
  { round: 17, team: "Chelsea FC", score: 29 },
  { round: 17, team: "Tottenham Hotspur FC", score: 26 },
  { round: 17, team: "Manchester United FC", score: 25 },
  { round: 17, team: "Sheffield United FC", score: 25 },
  { round: 17, team: "Wolverhampton Wanderers FC", score: 24 },
  { round: 17, team: "Crystal Palace FC", score: 23 },
  { round: 17, team: "Arsenal FC", score: 22 },
  { round: 17, team: "Newcastle United FC", score: 22 },
  { round: 17, team: "Burnley FC", score: 21 },
  { round: 17, team: "Brighton & Hove Albion FC", score: 20 },
  { round: 17, team: "AFC Bournemouth", score: 19 },
  { round: 17, team: "West Ham United FC", score: 19 },
  { round: 17, team: "Everton FC", score: 18 },
  { round: 17, team: "Aston Villa FC", score: 15 },
  { round: 17, team: "Southampton FC", score: 15 },
  { round: 17, team: "Norwich City FC", score: 12 },
  { round: 17, team: "Watford FC", score: 9 },
  { round: 18, team: "Liverpool FC", score: 52 },
  { round: 18, team: "Leicester City FC", score: 39 },
  { round: 18, team: "Manchester City FC", score: 38 },
  { round: 18, team: "Chelsea FC", score: 32 },
  { round: 18, team: "Sheffield United FC", score: 28 },
  { round: 18, team: "Wolverhampton Wanderers FC", score: 27 },
  { round: 18, team: "Tottenham Hotspur FC", score: 26 },
  { round: 18, team: "Newcastle United FC", score: 25 },
  { round: 18, team: "Manchester United FC", score: 25 },
  { round: 18, team: "Burnley FC", score: 24 },
  { round: 18, team: "Crystal Palace FC", score: 23 },
  { round: 18, team: "Arsenal FC", score: 23 },
  { round: 18, team: "Brighton & Hove Albion FC", score: 20 },
  { round: 18, team: "AFC Bournemouth", score: 19 },
  { round: 18, team: "Everton FC", score: 19 },
  { round: 18, team: "West Ham United FC", score: 19 },
  { round: 18, team: "Southampton FC", score: 18 },
  { round: 18, team: "Aston Villa FC", score: 15 },
  { round: 18, team: "Norwich City FC", score: 12 },
  { round: 18, team: "Watford FC", score: 12 },
  { round: 19, team: "Liverpool FC", score: 55 },
  { round: 19, team: "Leicester City FC", score: 39 },
  { round: 19, team: "Manchester City FC", score: 38 },
  { round: 19, team: "Chelsea FC", score: 32 },
  { round: 19, team: "Wolverhampton Wanderers FC", score: 30 },
  { round: 19, team: "Tottenham Hotspur FC", score: 29 },
  { round: 19, team: "Sheffield United FC", score: 29 },
  { round: 19, team: "Manchester United FC", score: 28 },
  { round: 19, team: "Crystal Palace FC", score: 26 },
  { round: 19, team: "Newcastle United FC", score: 25 },
  { round: 19, team: "Burnley FC", score: 24 },
  { round: 19, team: "Arsenal FC", score: 24 },
  { round: 19, team: "Everton FC", score: 22 },
  { round: 19, team: "Southampton FC", score: 21 },
  { round: 19, team: "AFC Bournemouth", score: 20 },
  { round: 19, team: "Brighton & Hove Albion FC", score: 20 },
  { round: 19, team: "West Ham United FC", score: 19 },
  { round: 19, team: "Aston Villa FC", score: 18 },
  { round: 19, team: "Watford FC", score: 13 },
  { round: 19, team: "Norwich City FC", score: 12 },
  { round: 20, team: "Liverpool FC", score: 58 },
  { round: 20, team: "Leicester City FC", score: 42 },
  { round: 20, team: "Manchester City FC", score: 41 },
  { round: 20, team: "Chelsea FC", score: 35 },
  { round: 20, team: "Manchester United FC", score: 31 },
  { round: 20, team: "Tottenham Hotspur FC", score: 30 },
  { round: 20, team: "Wolverhampton Wanderers FC", score: 30 },
  { round: 20, team: "Sheffield United FC", score: 29 },
  { round: 20, team: "Crystal Palace FC", score: 27 },
  { round: 20, team: "Everton FC", score: 25 },
  { round: 20, team: "Newcastle United FC", score: 25 },
  { round: 20, team: "Burnley FC", score: 24 },
  { round: 20, team: "Arsenal FC", score: 24 },
  { round: 20, team: "Brighton & Hove Albion FC", score: 23 },
  { round: 20, team: "Southampton FC", score: 22 },
  { round: 20, team: "AFC Bournemouth", score: 20 },
  { round: 20, team: "West Ham United FC", score: 19 },
  { round: 20, team: "Aston Villa FC", score: 18 },
  { round: 20, team: "Watford FC", score: 16 },
  { round: 20, team: "Norwich City FC", score: 13 },
  { round: 21, team: "Liverpool FC", score: 61 },
  { round: 21, team: "Leicester City FC", score: 45 },
  { round: 21, team: "Manchester City FC", score: 44 },
  { round: 21, team: "Chelsea FC", score: 36 },
  { round: 21, team: "Manchester United FC", score: 31 },
  { round: 21, team: "Tottenham Hotspur FC", score: 30 },
  { round: 21, team: "Wolverhampton Wanderers FC", score: 30 },
  { round: 21, team: "Sheffield United FC", score: 29 },
  { round: 21, team: "Crystal Palace FC", score: 28 },
  { round: 21, team: "Arsenal FC", score: 27 },
  { round: 21, team: "Everton FC", score: 25 },
  { round: 21, team: "Southampton FC", score: 25 },
  { round: 21, team: "Newcastle United FC", score: 25 },
  { round: 21, team: "Burnley FC", score: 24 },
  { round: 21, team: "Brighton & Hove Albion FC", score: 24 },
  { round: 21, team: "West Ham United FC", score: 22 },
  { round: 21, team: "Aston Villa FC", score: 21 },
  { round: 21, team: "AFC Bournemouth", score: 20 },
  { round: 21, team: "Watford FC", score: 19 },
  { round: 21, team: "Norwich City FC", score: 14 },
  { round: 22, team: "Liverpool FC", score: 64 },
  { round: 22, team: "Manchester City FC", score: 47 },
  { round: 22, team: "Leicester City FC", score: 45 },
  { round: 22, team: "Chelsea FC", score: 39 },
  { round: 22, team: "Manchester United FC", score: 34 },
  { round: 22, team: "Sheffield United FC", score: 32 },
  { round: 22, team: "Wolverhampton Wanderers FC", score: 31 },
  { round: 22, team: "Tottenham Hotspur FC", score: 30 },
  { round: 22, team: "Crystal Palace FC", score: 29 },
  { round: 22, team: "Everton FC", score: 28 },
  { round: 22, team: "Arsenal FC", score: 28 },
  { round: 22, team: "Southampton FC", score: 28 },
  { round: 22, team: "Newcastle United FC", score: 26 },
  { round: 22, team: "Brighton & Hove Albion FC", score: 24 },
  { round: 22, team: "Burnley FC", score: 24 },
  { round: 22, team: "Watford FC", score: 22 },
  { round: 22, team: "West Ham United FC", score: 22 },
  { round: 22, team: "Aston Villa FC", score: 21 },
  { round: 22, team: "AFC Bournemouth", score: 20 },
  { round: 22, team: "Norwich City FC", score: 14 },
  { round: 23, team: "Liverpool FC", score: 67 },
  { round: 23, team: "Manchester City FC", score: 48 },
  { round: 23, team: "Leicester City FC", score: 45 },
  { round: 23, team: "Chelsea FC", score: 39 },
  { round: 23, team: "Manchester United FC", score: 34 },
  { round: 23, team: "Wolverhampton Wanderers FC", score: 34 },
  { round: 23, team: "Sheffield United FC", score: 33 },
  { round: 23, team: "Tottenham Hotspur FC", score: 31 },
  { round: 23, team: "Crystal Palace FC", score: 30 },
  { round: 23, team: "Everton FC", score: 29 },
  { round: 23, team: "Arsenal FC", score: 29 },
  { round: 23, team: "Newcastle United FC", score: 29 },
  { round: 23, team: "Southampton FC", score: 28 },
  { round: 23, team: "Burnley FC", score: 27 },
  { round: 23, team: "Brighton & Hove Albion FC", score: 25 },
  { round: 23, team: "Watford FC", score: 23 },
  { round: 23, team: "West Ham United FC", score: 23 },
  { round: 23, team: "Aston Villa FC", score: 22 },
  { round: 23, team: "AFC Bournemouth", score: 20 },
  { round: 23, team: "Norwich City FC", score: 17 },
  { round: 24, team: "Liverpool FC", score: 70 },
  { round: 24, team: "Manchester City FC", score: 51 },
  { round: 24, team: "Leicester City FC", score: 48 },
  { round: 24, team: "Chelsea FC", score: 40 },
  { round: 24, team: "Manchester United FC", score: 34 },
  { round: 24, team: "Wolverhampton Wanderers FC", score: 34 },
  { round: 24, team: "Tottenham Hotspur FC", score: 34 },
  { round: 24, team: "Sheffield United FC", score: 33 },
  { round: 24, team: "Southampton FC", score: 31 },
  { round: 24, team: "Newcastle United FC", score: 30 },
  { round: 24, team: "Burnley FC", score: 30 },
  { round: 24, team: "Everton FC", score: 30 },
  { round: 24, team: "Crystal Palace FC", score: 30 },
  { round: 24, team: "Arsenal FC", score: 30 },
  { round: 24, team: "Aston Villa FC", score: 25 },
  { round: 24, team: "Brighton & Hove Albion FC", score: 25 },
  { round: 24, team: "AFC Bournemouth", score: 23 },
  { round: 24, team: "Watford FC", score: 23 },
  { round: 24, team: "West Ham United FC", score: 23 },
  { round: 24, team: "Norwich City FC", score: 17 },
  { round: 25, team: "Liverpool FC", score: 73 },
  { round: 25, team: "Manchester City FC", score: 51 },
  { round: 25, team: "Leicester City FC", score: 49 },
  { round: 25, team: "Chelsea FC", score: 41 },
  { round: 25, team: "Tottenham Hotspur FC", score: 37 },
  { round: 25, team: "Sheffield United FC", score: 36 },
  { round: 25, team: "Manchester United FC", score: 35 },
  { round: 25, team: "Wolverhampton Wanderers FC", score: 35 },
  { round: 25, team: "Everton FC", score: 33 },
  { round: 25, team: "Burnley FC", score: 31 },
  { round: 25, team: "Arsenal FC", score: 31 },
  { round: 25, team: "Southampton FC", score: 31 },
  { round: 25, team: "Newcastle United FC", score: 31 },
  { round: 25, team: "Crystal Palace FC", score: 30 },
  { round: 25, team: "AFC Bournemouth", score: 26 },
  { round: 25, team: "Brighton & Hove Albion FC", score: 26 },
  { round: 25, team: "Aston Villa FC", score: 25 },
  { round: 25, team: "West Ham United FC", score: 24 },
  { round: 25, team: "Watford FC", score: 23 },
  { round: 25, team: "Norwich City FC", score: 18 },
  { round: 26, team: "Liverpool FC", score: 76 },
  { round: 26, team: "Manchester City FC", score: 54 },
  { round: 26, team: "Leicester City FC", score: 50 },
  { round: 26, team: "Chelsea FC", score: 41 },
  { round: 26, team: "Tottenham Hotspur FC", score: 40 },
  { round: 26, team: "Sheffield United FC", score: 39 },
  { round: 26, team: "Manchester United FC", score: 38 },
  { round: 26, team: "Everton FC", score: 36 },
  { round: 26, team: "Wolverhampton Wanderers FC", score: 36 },
  { round: 26, team: "Burnley FC", score: 34 },
  { round: 26, team: "Arsenal FC", score: 34 },
  { round: 26, team: "Southampton FC", score: 31 },
  { round: 26, team: "Newcastle United FC", score: 31 },
  { round: 26, team: "Crystal Palace FC", score: 30 },
  { round: 26, team: "Brighton & Hove Albion FC", score: 27 },
  { round: 26, team: "AFC Bournemouth", score: 26 },
  { round: 26, team: "Aston Villa FC", score: 25 },
  { round: 26, team: "West Ham United FC", score: 24 },
  { round: 26, team: "Watford FC", score: 24 },
  { round: 26, team: "Norwich City FC", score: 18 },
  { round: 27, team: "Liverpool FC", score: 79 },
  { round: 27, team: "Manchester City FC", score: 57 },
  { round: 27, team: "Leicester City FC", score: 50 },
  { round: 27, team: "Chelsea FC", score: 44 },
  { round: 27, team: "Manchester United FC", score: 41 },
  { round: 27, team: "Sheffield United FC", score: 40 },
  { round: 27, team: "Tottenham Hotspur FC", score: 40 },
  { round: 27, team: "Wolverhampton Wanderers FC", score: 39 },
  { round: 27, team: "Burnley FC", score: 37 },
  { round: 27, team: "Arsenal FC", score: 37 },
  { round: 27, team: "Everton FC", score: 36 },
  { round: 27, team: "Southampton FC", score: 34 },
  { round: 27, team: "Crystal Palace FC", score: 33 },
  { round: 27, team: "Newcastle United FC", score: 31 },
  { round: 27, team: "Brighton & Hove Albion FC", score: 28 },
  { round: 27, team: "AFC Bournemouth", score: 26 },
  { round: 27, team: "Aston Villa FC", score: 25 },
  { round: 27, team: "West Ham United FC", score: 24 },
  { round: 27, team: "Watford FC", score: 24 },
  { round: 27, team: "Norwich City FC", score: 18 },
  { round: 28, team: "Liverpool FC", score: 79 },
  { round: 28, team: "Manchester City FC", score: 60 },
  { round: 28, team: "Leicester City FC", score: 50 },
  { round: 28, team: "Chelsea FC", score: 45 },
  { round: 28, team: "Manchester United FC", score: 42 },
  { round: 28, team: "Wolverhampton Wanderers FC", score: 42 },
  { round: 28, team: "Sheffield United FC", score: 41 },
  { round: 28, team: "Tottenham Hotspur FC", score: 40 },
  { round: 28, team: "Burnley FC", score: 38 },
  { round: 28, team: "Everton FC", score: 37 },
  { round: 28, team: "Arsenal FC", score: 37 },
  { round: 28, team: "Crystal Palace FC", score: 36 },
  { round: 28, team: "Southampton FC", score: 34 },
  { round: 28, team: "Newcastle United FC", score: 32 },
  { round: 28, team: "Brighton & Hove Albion FC", score: 28 },
  { round: 28, team: "AFC Bournemouth", score: 27 },
  { round: 28, team: "Watford FC", score: 27 },
  { round: 28, team: "West Ham United FC", score: 27 },
  { round: 28, team: "Aston Villa FC", score: 26 },
  { round: 28, team: "Norwich City FC", score: 21 },
  { round: 29, team: "Liverpool FC", score: 82 },
  { round: 29, team: "Manchester City FC", score: 60 },
  { round: 29, team: "Leicester City FC", score: 53 },
  { round: 29, team: "Chelsea FC", score: 48 },
  { round: 29, team: "Manchester United FC", score: 45 },
  { round: 29, team: "Sheffield United FC", score: 44 },
  { round: 29, team: "Wolverhampton Wanderers FC", score: 43 },
  { round: 29, team: "Tottenham Hotspur FC", score: 41 },
  { round: 29, team: "Arsenal FC", score: 40 },
  { round: 29, team: "Burnley FC", score: 39 },
  { round: 29, team: "Crystal Palace FC", score: 39 },
  { round: 29, team: "Everton FC", score: 37 },
  { round: 29, team: "Newcastle United FC", score: 35 },
  { round: 29, team: "Southampton FC", score: 34 },
  { round: 29, team: "Brighton & Hove Albion FC", score: 29 },
  { round: 29, team: "AFC Bournemouth", score: 27 },
  { round: 29, team: "Watford FC", score: 27 },
  { round: 29, team: "West Ham United FC", score: 27 },
  { round: 29, team: "Aston Villa FC", score: 26 },
  { round: 29, team: "Norwich City FC", score: 21 },
  { round: 30, team: "Liverpool FC", score: 83 },
  { round: 30, team: "Manchester City FC", score: 63 },
  { round: 30, team: "Leicester City FC", score: 54 },
  { round: 30, team: "Chelsea FC", score: 51 },
  { round: 30, team: "Manchester United FC", score: 46 },
  { round: 30, team: "Wolverhampton Wanderers FC", score: 46 },
  { round: 30, team: "Sheffield United FC", score: 44 },
  { round: 30, team: "Crystal Palace FC", score: 42 },
  { round: 30, team: "Tottenham Hotspur FC", score: 42 },
  { round: 30, team: "Arsenal FC", score: 40 },
  { round: 30, team: "Burnley FC", score: 39 },
  { round: 30, team: "Everton FC", score: 38 },
  { round: 30, team: "Newcastle United FC", score: 38 },
  { round: 30, team: "Southampton FC", score: 37 },
  { round: 30, team: "Brighton & Hove Albion FC", score: 32 },
  { round: 30, team: "Watford FC", score: 28 },
  { round: 30, team: "West Ham United FC", score: 27 },
  { round: 30, team: "AFC Bournemouth", score: 27 },
  { round: 30, team: "Aston Villa FC", score: 26 },
  { round: 30, team: "Norwich City FC", score: 21 },
  { round: 31, team: "Liverpool FC", score: 86 },
  { round: 31, team: "Manchester City FC", score: 63 },
  { round: 31, team: "Leicester City FC", score: 55 },
  { round: 31, team: "Chelsea FC", score: 54 },
  { round: 31, team: "Manchester United FC", score: 49 },
  { round: 31, team: "Wolverhampton Wanderers FC", score: 49 },
  { round: 31, team: "Tottenham Hotspur FC", score: 45 },
  { round: 31, team: "Sheffield United FC", score: 44 },
  { round: 31, team: "Arsenal FC", score: 43 },
  { round: 31, team: "Burnley FC", score: 42 },
  { round: 31, team: "Crystal Palace FC", score: 42 },
  { round: 31, team: "Everton FC", score: 41 },
  { round: 31, team: "Newcastle United FC", score: 39 },
  { round: 31, team: "Southampton FC", score: 37 },
  { round: 31, team: "Brighton & Hove Albion FC", score: 33 },
  { round: 31, team: "Watford FC", score: 28 },
  { round: 31, team: "West Ham United FC", score: 27 },
  { round: 31, team: "Aston Villa FC", score: 27 },
  { round: 31, team: "AFC Bournemouth", score: 27 },
  { round: 31, team: "Norwich City FC", score: 21 },
  { round: 32, team: "Liverpool FC", score: 86 },
  { round: 32, team: "Manchester City FC", score: 66 },
  { round: 32, team: "Leicester City FC", score: 55 },
  { round: 32, team: "Chelsea FC", score: 54 },
  { round: 32, team: "Manchester United FC", score: 52 },
  { round: 32, team: "Wolverhampton Wanderers FC", score: 52 },
  { round: 32, team: "Sheffield United FC", score: 47 },
  { round: 32, team: "Arsenal FC", score: 46 },
  { round: 32, team: "Burnley FC", score: 45 },
  { round: 32, team: "Tottenham Hotspur FC", score: 45 },
  { round: 32, team: "Everton FC", score: 44 },
  { round: 32, team: "Crystal Palace FC", score: 42 },
  { round: 32, team: "Newcastle United FC", score: 42 },
  { round: 32, team: "Southampton FC", score: 40 },
  { round: 32, team: "Brighton & Hove Albion FC", score: 33 },
  { round: 32, team: "West Ham United FC", score: 30 },
  { round: 32, team: "Watford FC", score: 28 },
  { round: 32, team: "Aston Villa FC", score: 27 },
  { round: 32, team: "AFC Bournemouth", score: 27 },
  { round: 32, team: "Norwich City FC", score: 21 },
  { round: 33, team: "Liverpool FC", score: 89 },
  { round: 33, team: "Manchester City FC", score: 66 },
  { round: 33, team: "Leicester City FC", score: 58 },
  { round: 33, team: "Chelsea FC", score: 57 },
  { round: 33, team: "Manchester United FC", score: 55 },
  { round: 33, team: "Wolverhampton Wanderers FC", score: 52 },
  { round: 33, team: "Arsenal FC", score: 49 },
  { round: 33, team: "Sheffield United FC", score: 48 },
  { round: 33, team: "Tottenham Hotspur FC", score: 48 },
  { round: 33, team: "Burnley FC", score: 46 },
  { round: 33, team: "Everton FC", score: 44 },
  { round: 33, team: "Southampton FC", score: 43 },
  { round: 33, team: "Newcastle United FC", score: 43 },
  { round: 33, team: "Crystal Palace FC", score: 42 },
  { round: 33, team: "Brighton & Hove Albion FC", score: 36 },
  { round: 33, team: "West Ham United FC", score: 31 },
  { round: 33, team: "Watford FC", score: 28 },
  { round: 33, team: "Aston Villa FC", score: 27 },
  { round: 33, team: "AFC Bournemouth", score: 27 },
  { round: 33, team: "Norwich City FC", score: 21 },
  { round: 34, team: "Liverpool FC", score: 92 },
  { round: 34, team: "Manchester City FC", score: 69 },
  { round: 34, team: "Chelsea FC", score: 60 },
  { round: 34, team: "Leicester City FC", score: 59 },
  { round: 34, team: "Manchester United FC", score: 58 },
  { round: 34, team: "Wolverhampton Wanderers FC", score: 52 },
  { round: 34, team: "Sheffield United FC", score: 51 },
  { round: 34, team: "Arsenal FC", score: 50 },
  { round: 34, team: "Burnley FC", score: 49 },
  { round: 34, team: "Tottenham Hotspur FC", score: 49 },
  { round: 34, team: "Everton FC", score: 45 },
  { round: 34, team: "Southampton FC", score: 44 },
  { round: 34, team: "Newcastle United FC", score: 43 },
  { round: 34, team: "Crystal Palace FC", score: 42 },
  { round: 34, team: "Brighton & Hove Albion FC", score: 36 },
  { round: 34, team: "Watford FC", score: 31 },
  { round: 34, team: "West Ham United FC", score: 31 },
  { round: 34, team: "AFC Bournemouth", score: 28 },
  { round: 34, team: "Aston Villa FC", score: 27 },
  { round: 34, team: "Norwich City FC", score: 21 },
  { round: 35, team: "Liverpool FC", score: 93 },
  { round: 35, team: "Manchester City FC", score: 72 },
  { round: 35, team: "Chelsea FC", score: 60 },
  { round: 35, team: "Manchester United FC", score: 59 },
  { round: 35, team: "Leicester City FC", score: 59 },
  { round: 35, team: "Wolverhampton Wanderers FC", score: 55 },
  { round: 35, team: "Sheffield United FC", score: 54 },
  { round: 35, team: "Tottenham Hotspur FC", score: 52 },
  { round: 35, team: "Burnley FC", score: 50 },
  { round: 35, team: "Arsenal FC", score: 50 },
  { round: 35, team: "Everton FC", score: 45 },
  { round: 35, team: "Southampton FC", score: 45 },
  { round: 35, team: "Newcastle United FC", score: 43 },
  { round: 35, team: "Crystal Palace FC", score: 42 },
  { round: 35, team: "Brighton & Hove Albion FC", score: 36 },
  { round: 35, team: "Watford FC", score: 34 },
  { round: 35, team: "West Ham United FC", score: 34 },
  { round: 35, team: "AFC Bournemouth", score: 31 },
  { round: 35, team: "Aston Villa FC", score: 30 },
  { round: 35, team: "Norwich City FC", score: 21 },
  { round: 36, team: "Liverpool FC", score: 93 },
  { round: 36, team: "Manchester City FC", score: 75 },
  { round: 36, team: "Chelsea FC", score: 63 },
  { round: 36, team: "Manchester United FC", score: 62 },
  { round: 36, team: "Leicester City FC", score: 62 },
  { round: 36, team: "Wolverhampton Wanderers FC", score: 56 },
  { round: 36, team: "Tottenham Hotspur FC", score: 55 },
  { round: 36, team: "Sheffield United FC", score: 54 },
  { round: 36, team: "Arsenal FC", score: 53 },
  { round: 36, team: "Burnley FC", score: 51 },
  { round: 36, team: "Everton FC", score: 46 },
  { round: 36, team: "Southampton FC", score: 46 },
  { round: 36, team: "Newcastle United FC", score: 43 },
  { round: 36, team: "Crystal Palace FC", score: 42 },
  { round: 36, team: "Brighton & Hove Albion FC", score: 37 },
  { round: 36, team: "West Ham United FC", score: 37 },
  { round: 36, team: "Watford FC", score: 34 },
  { round: 36, team: "Aston Villa FC", score: 31 },
  { round: 36, team: "AFC Bournemouth", score: 31 },
  { round: 36, team: "Norwich City FC", score: 21 },
  { round: 37, team: "Liverpool FC", score: 96 },
  { round: 37, team: "Manchester City FC", score: 78 },
  { round: 37, team: "Manchester United FC", score: 63 },
  { round: 37, team: "Chelsea FC", score: 63 },
  { round: 37, team: "Leicester City FC", score: 62 },
  { round: 37, team: "Wolverhampton Wanderers FC", score: 59 },
  { round: 37, team: "Tottenham Hotspur FC", score: 58 },
  { round: 37, team: "Sheffield United FC", score: 54 },
  { round: 37, team: "Burnley FC", score: 54 },
  { round: 37, team: "Arsenal FC", score: 53 },
  { round: 37, team: "Everton FC", score: 49 },
  { round: 37, team: "Southampton FC", score: 49 },
  { round: 37, team: "Newcastle United FC", score: 44 },
  { round: 37, team: "Crystal Palace FC", score: 42 },
  { round: 37, team: "Brighton & Hove Albion FC", score: 38 },
  { round: 37, team: "West Ham United FC", score: 38 },
  { round: 37, team: "Watford FC", score: 34 },
  { round: 37, team: "Aston Villa FC", score: 34 },
  { round: 37, team: "AFC Bournemouth", score: 31 },
  { round: 37, team: "Norwich City FC", score: 21 },
  { round: 38, team: "Liverpool FC", score: 99 },
  { round: 38, team: "Manchester City FC", score: 81 },
  { round: 38, team: "Manchester United FC", score: 66 },
  { round: 38, team: "Chelsea FC", score: 66 },
  { round: 38, team: "Leicester City FC", score: 62 },
  { round: 38, team: "Tottenham Hotspur FC", score: 59 },
  { round: 38, team: "Wolverhampton Wanderers FC", score: 59 },
  { round: 38, team: "Arsenal FC", score: 56 },
  { round: 38, team: "Burnley FC", score: 54 },
  { round: 38, team: "Sheffield United FC", score: 54 },
  { round: 38, team: "Southampton FC", score: 52 },
  { round: 38, team: "Everton FC", score: 49 },
  { round: 38, team: "Newcastle United FC", score: 44 },
  { round: 38, team: "Crystal Palace FC", score: 43 },
  { round: 38, team: "Brighton & Hove Albion FC", score: 41 },
  { round: 38, team: "West Ham United FC", score: 39 },
  { round: 38, team: "Aston Villa FC", score: 35 },
  { round: 38, team: "AFC Bournemouth", score: 34 },
  { round: 38, team: "Watford FC", score: 34 },
  { round: 38, team: "Norwich City FC", score: 21 },
];
